import { CSSProperties } from "react";

type IconProps = { className?: string; style?: CSSProperties };

const sharedSvgAttrs = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  role: "img" as const,
};

// Rows of (key, value) pairs: a small label on the left paired with a
// longer value bar on the right. Evokes the agent looking something up by
// a specific key — the defining behavior of associative key-value memory.
export const KVStoreIcon = ({ className, style }: IconProps) => (
  <svg
    {...sharedSvgAttrs}
    className={className}
    style={style}
    aria-label="KV store"
  >
    <rect x="1.5" y="2" width="3" height="2" rx="0.4" />
    <rect x="6" y="2" width="8.5" height="2" rx="0.4" />
    <rect x="1.5" y="7" width="3" height="2" rx="0.4" />
    <rect x="6" y="7" width="8.5" height="2" rx="0.4" />
    <rect x="1.5" y="12" width="3" height="2" rx="0.4" />
    <rect x="6" y="12" width="8.5" height="2" rx="0.4" />
  </svg>
);

// A short stack of memory cells inside brackets: evokes a bounded
// recency buffer — the most recent N items the agent is holding onto.
export const LimitedListIcon = ({ className, style }: IconProps) => (
  <svg
    {...sharedSvgAttrs}
    className={className}
    style={style}
    aria-label="Limited list"
  >
    <path
      d="M3.5 1.5 L1.5 1.5 L1.5 14.5 L3.5 14.5 M12.5 1.5 L14.5 1.5 L14.5 14.5 L12.5 14.5"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="8" cy="4" r="1.5" />
    <circle cx="8" cy="8" r="1.5" />
    <circle cx="8" cy="12" r="1.5" />
  </svg>
);

export const ComponentTypeIcon = ({
  type,
  className,
  style,
}: {
  type?: string;
  className?: string;
  style?: CSSProperties;
}) => {
  if (type === "kv_store" || type === "puppeteer_kv_store") {
    return <KVStoreIcon className={className} style={style} />;
  }
  if (type === "limited_list" || type === "puppeteer_limited_list") {
    return <LimitedListIcon className={className} style={style} />;
  }
  return null;
};
